import type { IExportAccessRepository } from '../repositories/IExportAccessRepository.js';
import type { ExportGrantEntity } from '../entities/ExportAccessEntity.js';

interface Deps { exportAccessRepository: IExportAccessRepository; }
export function createListExportGrantsUseCase({ exportAccessRepository }: Deps) {
  return async function listExportGrants(): Promise<ExportGrantEntity[]> {
    return exportAccessRepository.listGrants();
  };
}
